import { BorderType, MarginType } from 'common/types/styleTypes'
import {
  borderCss,
  marginCss,
  mobileBorderCss,
  mobileMarginCss,
} from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

export interface TwoStepPaymentFormUiProps {
  border: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  margin?: Partial<MarginType>
  mobileMargin?: Partial<MarginType>
}

const TwoStepPaymentFormUi = styled.div<TwoStepPaymentFormUiProps>`
  overflow: hidden;
  ${borderCss}
  ${marginCss}

  ${p => p.theme.phone} {
    ${mobileBorderCss}
    ${mobileMarginCss}
  }
`

export default TwoStepPaymentFormUi
